import { render, staticRenderFns } from "./RegisterVacationRequestDrawer.vue?vue&type=template&id=5521d83f&scoped=true&"
import script from "./RegisterVacationRequestDrawer.vue?vue&type=script&lang=js&"
export * from "./RegisterVacationRequestDrawer.vue?vue&type=script&lang=js&"
import style0 from "./RegisterVacationRequestDrawer.vue?vue&type=style&index=0&id=5521d83f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5521d83f",
  null
  
)

export default component.exports